import {useCallback} from 'react';

import {RolesAccount} from '@/app/auth';
import {TEEN_PRELOAD_CARD_DATA_EVENTS} from '@/app/auth/events/TeenPreloadDataEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackViewOnboardingKidName = useCallback(
    (themeSelected: string, parentId: string) => {
      trackEvent(TEEN_PRELOAD_CARD_DATA_EVENTS.VIEW_ONBOARDING_KID_NAME, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        user: {
          id: parentId ?? '',
          role: RolesAccount.PARENT,
        },
      });
    },
    [trackEvent],
  );

  const trackSelectOnboardingKidNameContinue = useCallback(
    (themeSelected: string, parentId: string) => {
      trackEvent(
        TEEN_PRELOAD_CARD_DATA_EVENTS.SELECT_ONBOARDING_KID_NAME_CONTINUE,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
          Banking: {
            card: {
              theme: {
                name: themeSelected ?? '',
              },
            },
          },
          user: {
            id: parentId ?? '',
            role: RolesAccount.PARENT,
          },
        },
      );
    },
    [trackEvent],
  );

  const trackSelectOnboardingChangeCardTheme = useCallback(
    (themeSelected: string, parentId: string) => {
      trackEvent(
        TEEN_PRELOAD_CARD_DATA_EVENTS.SELECT_ONBOARDING_CHANGE_CARD_THEME,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
          Banking: {
            card: {
              theme: {
                name: themeSelected ?? '',
              },
            },
          },
          user: {
            id: parentId ?? '',
            role: RolesAccount.PARENT,
          },
        },
      );
    },
    [trackEvent],
  );

  return {
    trackViewOnboardingKidName,
    trackSelectOnboardingKidNameContinue,
    trackSelectOnboardingChangeCardTheme,
  };
};
